import { useState } from "react";

    
    
export default function usePagination(defaultPage?: number, defaultLimit?: number, defaultSortBy?: string, defaultSort?: string) {

    const [page, setPage] = useState(defaultPage ?? 1);
    const [limit, setLimit] = useState(defaultLimit ?? 15);
    const [sort, setSort] = useState({ order: defaultSort ?? 'DESC', orderBy: defaultSortBy ?? 'id' });

    return {
        page, setPage, limit, setLimit, sort, setSort
    }
}